import Vue from 'vue'
import Confirm from './confirm.vue'
import Delete from './delete.vue'
import { isString, isFunction, isArray } from 'util'
import { mergeObjs, deepCopy } from '@/utils/miscUtil'

function Each(value, callback) {
    // 非数组
    if (!isArray(value)) {
        return callback(value)
    }
    // 数组
    else {
        let result = []

        const vs = [...value]
        while (vs.length) {
            const item = vs.shift()
            result.push(callback(item))
        }

        return result
    }
}

/************************放在外面避免被监听（start）************************** */

// 原对象
const components = []
// 实例对象
const vueComponents = []

// 查找vue实例
function searchVueInstance(modal) {
    let _modal, i

    // 已经实例化的vue对象
    if (modal instanceof Vue) {
        i = vueComponents.indexOf(modal)

        // 一直搜索到根实例
        while (i == -1 && modal.$parent) {
            modal = modal.$parent
            i = vueComponents.indexOf(modal)
        }

        _modal = modal
    }
    // 未实例化的vue组件
    else {
        i = components.indexOf(modal)
        _modal = vueComponents[i]
    }
    return [i, _modal]
}

// 新建vue实例
function newVueInstance(modal, opt_options, store) {
    let _modal = modal

    // 如果是vue组件
    if (!(modal instanceof Vue)) {
        const options = deepCopy(opt_options)
        const Instance = new Vue({
            store: store,
            render(h) {
                return h(modal, mergeObjs({}, options))
            }
        })
        _modal = Instance.$mount()
    }

    // 添加节点
    document.body.appendChild(_modal.$el)

    return _modal
}

// 销毁vue实例
function destroyVueInstance(modal) {
    if (modal instanceof Vue) {
        try {
            modal.$el.parentNode.removeChild(modal.$el)
            modal.$destroy()

            return true
        } catch (error) {
            console.error('flowWindow destroy:', modal)

            return false
        }
    }
    return true
}

/* ************************************************************************ */

// dialog管理器
let store_ = null

export const dialogManager = {
    set store(value) {
        store_ = value
    },

    /**
     * 添加实例
     * @param {*} modal
     */
    addOne(modal, opt_options) {
        // new vue
        let _modal = newVueInstance(modal, opt_options, store_)

        // store instance
        vueComponents.push(_modal)
        components.push(modal)

        return _modal.$children[0]
    },
    /**
     * 移除实例
     * @param {*} modal
     */
    removeOne(modal) {
        // search vue
        const [i, _modal] = searchVueInstance(modal)

        // destroy vue
        if (_modal) {
            destroyVueInstance(_modal)
        }
        // unstore
        if (i !== -1) {
            vueComponents.splice(i, 1)
            components.splice(i, 1)
        }
    },
    /**
     * 添加一个或多个modal
     * @param {*} modals
     * @param {*} opt_options
     */
    add(modals, opt_options) {
        return Each(modals, item => this.addOne(item, opt_options))
    },
    /**
     * 删除一个或多个modal
     * @param {*} modals
     */
    remove(modals) {
        Each(modals, item => this.removeOne(item))
    },
    /**
     * 同组件只能添加一个
     * @param {*} modals
     * @param {*} opt_options
     */
    checkAdd(modals, opt_options) {
        Each(modals, item => {
            const [i] = searchVueInstance(item)
            if (i === -1) {
                this.addOne(item, opt_options)
            }
        })
    },
    /**
     * 移除同类型组件
     * @param {*} modals
     */
    removeSame(modals) {
        Each(modals, item => {
            let _modal, i
            do {
                ;[i, _modal] = searchVueInstance(item)

                // destroy vue
                if (_modal) {
                    destroyVueInstance(_modal)
                }
                // unstore
                if (i !== -1) {
                    vueComponents.splice(i, 1)
                    components.splice(i, 1)
                }
            } while (i !== -1)
        })
    },
    /**
     * 检查指定组件有没有添加
     * @param {*} modal
     */
    checkState(modal) {
        const [i] = searchVueInstance(modal)
        if (i === -1) {
            return false
        }
        return true
    },
    /**
     * 删除全部实例
     */
    removeAll() {
        do {
            const modal = vueComponents.shift()
            components.shift()
            destroyVueInstance(modal)
        } while (vueComponents.length > 0)
    }
}

// 默认导出（常用modal）
export default {
    confirm(option) {
        return this.openDialog(Confirm, option)
    },
    delete(option) {
        return this.openDialog(Delete, option)
    },
    openDialog(comp, option) {
        let props = {},
            onOk,
            onCancel

        if (isString(option)) {
            props = { message: option }
        } else {
            onOk = option.onOk
            onCancel = option.onCancel
            props = { ...option }
        }

        // 去除当前焦点元素
        document.querySelector('*:focus') &&
            document.querySelector('*:focus').blur()

        const modal = dialogManager.addOne(comp, { props })

        modal.$on('on-cancel', function() {
            if (isFunction(onCancel)) {
                onCancel()
            }
            dialogManager.removeOne(modal)
        })

        modal.$on('on-ok', function() {
            if (isFunction(onOk)) {
                onOk()
            }
            dialogManager.removeOne(modal)
        })

        return modal
    }
}
